<div class="modal-header">
    <h4 class="modal-title">Signaler un incident</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p>
        Confirmez-vous le signalement d'un incident pour la session <strong>{{ examSession.code }}</strong> ?
    </p>
    <p>
        Un email de notification sera envoyé aux personnes concernées.
    </p>
    <form [formGroup]="form">
        <div class="form-group">
            <label for="incident-comment">Description de l'incident (optionnel)</label>
            <textarea class="form-control" id="incident-comment" formControlName="comment"
                placeholder="Décrivez l'incident constaté"></textarea>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">Annuler</button>
    <button type="button" class="btn btn-outline-warning" (click)="submit()" [disabled]="submitting">
        <span *ngIf="submitting" class="button-loader"></span>
        Signaler
    </button>
</div>
